const toNum = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : NaN;
};

export const computeAmount = (unitPrice, quantity) => {
  const p = toNum(unitPrice);
  const q = toNum(quantity);
  if (!(p >= 0) || !(q > 0)) return '';
  return (Math.round(p * q * 100) / 100).toFixed(2);
};

export const computeUnitPrice = (amount, quantity) => {
  const a = toNum(amount);
  const q = toNum(quantity);
  if (!(a >= 0) || !(q > 0)) return '';
  return (Math.round((a / q) * 100) / 100).toFixed(2);
};

export const priceDiffers = (unitPrice, listPrice) => {
  const u = toNum(unitPrice);
  const l = toNum(listPrice);
  if (Number.isNaN(u) || Number.isNaN(l)) return false;
  return Math.abs(u - l) >= 0.005;
};

// Signed difference from list price: { diff, percent } or null when equal/unknown.
export const priceDelta = (unitPrice, listPrice) => {
  const u = toNum(unitPrice);
  const l = toNum(listPrice);
  if (Number.isNaN(u) || Number.isNaN(l) || l <= 0) return null;
  if (!priceDiffers(u, l)) return null;
  return {
    diff: Math.round((u - l) * 100) / 100,
    percent: Math.round(((u - l) / l) * 1000) / 10
  };
};
